import { IRequester, requester } from "src/libraries/requester";
import { IResponse } from "src/libraries/requester/IRequester/IResponse";
import { ILinks, links } from "src/Links";
import { IListResponse } from "./IResponse";
import { UpdatePlatformDto } from "./dto/update-platform-dto";

class ForceUpdateService {
    constructor(
        private requester: IRequester,
        private links: ILinks,
    ) { }

    list = async (): Promise<IResponse<IListResponse>> => {
        try {
            const response = await this.requester.get(this.links.platforms);
            return response;
        } catch (error) {
            console.warn('forceUpdateService -> list: ', this.links.platforms, error);
            return { isError: true, data: null, message: '' } as any;
        }
    };

    update = async (body: UpdatePlatformDto) => {
        try {
            const url = `${this.links.platforms}`;
            const response = await this.requester.patch(url, body);
            return response;
        } catch (error) {
            console.warn('forceUpdateService -> update: ', this.links.platforms, error);
            return { isError: true, data: null, message: '' } as any;
        }
    };
};

export const forceUpdateService = new ForceUpdateService(requester, links);
